import React from 'react';

export default function LogViewerPageFeedback({ pending, failed, count }: {
  pending: boolean;
  failed: boolean;
  count: number;
}) {
  let message: string;
  if (pending) {
    message = count > 0
      ? 'Loading events… Previous results remain below.'
      : 'Loading events…';
  } else if (failed) {
    message = count > 0
      ? 'Could not load events. Previous results remain below. Use Load logs to retry.'
      : 'Could not load events. Use Load logs to retry.';
  } else {
    message = count > 0
      ? `${count} ${count === 1 ? 'event' : 'events'} loaded.`
      : 'No events match this query. Adjust the filters or use Reset to broaden the search.';
  }
  return <p role="status" aria-live="polite" aria-atomic="true">{message}</p>;
}
